var _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path33, _rect18, _rect19, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 385,
    height: 276,
    viewBox: "0 0 385 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6859 135.109C81.9267 136.557 93.8191 143.213 105.768 151.076C122.584 162.14 146.755 169.185 149.689 189.066C152.706 209.504 133.11 225.128 118.918 240.173C104.06 255.924 89.3664 275.942 67.6859 276C45.9817 276.058 29.4805 257.557 16.1788 240.448C4.71931 225.709 -0.811774 207.697 0.0962064 189.066C0.95733 171.397 7.10918 153.501 20.9548 142.448C33.7539 132.231 51.3776 133.45 67.6859 135.109Z",
    fill: "url(#paint0_linear_625_2649)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.83 134.486C345.736 143.532 332.62 147.234 318.611 150.124C298.897 154.191 276.824 166.301 260.691 154.318C244.106 141.999 246.915 117.095 246.311 96.4209C245.68 74.7775 241.915 50.2326 257.205 34.8613C272.511 19.4731 297.261 20.8874 318.765 23.5793C337.29 25.8984 353.938 34.7238 366.47 48.5397C378.355 61.6427 386.659 78.6465 384.684 96.2525C382.858 112.528 369.535 124.128 356.83 134.486Z",
    fill: "url(#paint1_linear_625_2649)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85.7715,
    y: 37.8428,
    width: 226.228,
    height: 193.158,
    fill: "#6A75D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.87 73.2588L129.844 64.1865H128.12L124.776 69.8243L121.381 64.1865H119.644V73.2588H121.614V67.9321L124.271 72.2997H125.217L127.887 67.8154L127.9 73.2588H129.87Z",
    fill: "#A1C3FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.391 73.2588H172.49V65.8973H175.393V64.1865H167.487V65.8973H170.391V73.2588Z",
    fill: "#A1C3FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.027 65.2085L223.914 71.6368L221.84 65.2085H219.896L217.758 71.585L215.71 65.2085H213.533L216.514 74.2808H218.756L220.816 68.1375L222.812 74.2808H225.067L228.035 65.2085H226.027Z",
    fill: "#A1C3FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266.088 74.2808H268.188V66.9192H271.091V65.2085H263.185V66.9192H266.088V74.2808Z",
    fill: "#A1C3FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 139.946,
    y: 41.8779,
    width: 26.4696,
    height: 11.2344,
    rx: 2.59209,
    fill: "#A1C3FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 145.952,
    y: 15.3228,
    width: 14.2529,
    height: 32.682,
    rx: 3.88813,
    fill: "#8164F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 232.028,
    y: 41.8779,
    width: 26.4696,
    height: 11.2344,
    rx: 2.59209,
    fill: "#A1C3FC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 238.032,
    y: 15.3228,
    width: 14.2529,
    height: 32.682,
    rx: 3.88813,
    fill: "#8164F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 106.351,
    y: 77.0439,
    width: 40.9236,
    height: 41.0544,
    fill: "#A1C3FC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 106.351,
    y: 124.067,
    width: 40.9236,
    height: 41.0544,
    fill: "#1C2868"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 106.351,
    y: 171.095,
    width: 40.9236,
    height: 41.0544,
    fill: "#A1C3FC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 154.201,
    y: 77.0439,
    width: 40.9236,
    height: 41.0544,
    fill: "#A1C3FC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 153.971,
    y: 124.067,
    width: 40.9236,
    height: 41.0544,
    fill: "#A1C3FC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 153.971,
    y: 171.095,
    width: 40.9236,
    height: 41.0544,
    fill: "#1C2868"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 202.049,
    y: 77.0439,
    width: 40.9236,
    height: 41.0544,
    fill: "#A1C3FC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 201.592,
    y: 124.067,
    width: 40.9236,
    height: 41.0544,
    fill: "#A1C3FC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 201.592,
    y: 171.095,
    width: 40.9236,
    height: 41.0544,
    fill: "#A1C3FC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 248.88,
    y: 77.0439,
    width: 40.9236,
    height: 41.0544,
    fill: "#1C2868"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 249.212,
    y: 124.067,
    width: 40.9236,
    height: 41.0544,
    fill: "#1C2868"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 249.212,
    y: 171.095,
    width: 40.9236,
    height: 41.0544,
    fill: "#A1C3FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.826 136.233H111.976V143.105H118.826V136.233Z",
    fill: "#8C30F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.331 136.233H118.482V143.105H125.331V136.233Z",
    fill: "#D6B1FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.838 129.707H124.989V136.578H131.838V129.707Z",
    fill: "#2EC5CE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.838 142.762H124.989V149.634H131.838V142.762Z",
    fill: "#75E3EA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.838 149.289H124.989V156.16H131.838V149.289Z",
    fill: "#2EC5CE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.347 136.233H131.497V143.105H138.347V136.233Z",
    fill: "#D6B1FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.838 136.233H124.989V143.105H131.838V136.233Z",
    fill: "#8C30F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M269.386 155.293C274.004 155.293 277.748 151.538 277.748 146.905C277.748 142.273 274.004 138.517 269.386 138.517C264.768 138.517 261.025 142.273 261.025 146.905C261.025 151.538 264.768 155.293 269.386 155.293Z",
    fill: "#2EC5CE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M271.622 133.022H267.438C266.658 133.022 266.016 133.667 266.016 134.451C266.016 135.235 266.658 135.88 267.438 135.88H268.108V138.821H270.952V135.88H271.622C272.403 135.88 273.044 135.235 273.044 134.451C273.044 133.667 272.403 133.022 271.622 133.022Z",
    fill: "#8C30F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M262.14 137.613L263.925 136.494C264.26 136.268 264.706 136.381 264.901 136.717C265.124 137.055 265.013 137.503 264.678 137.697L264.399 137.868L265.375 139.436C265.459 139.574 265.431 139.742 265.291 139.829L264.566 140.274C264.427 140.361 264.26 140.332 264.176 140.191L263.2 138.623L262.921 138.791C262.586 139.016 262.14 138.903 261.945 138.568C261.722 138.258 261.805 137.839 262.14 137.613Z",
    fill: "#2EC5CE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M277.422 137.813L275.721 136.581C275.414 136.358 274.968 136.413 274.717 136.749C274.494 137.058 274.55 137.507 274.884 137.758L275.163 137.955L274.076 139.439C273.992 139.578 274.02 139.745 274.131 139.832L274.829 140.335C274.968 140.419 275.135 140.39 275.219 140.278L276.307 138.794L276.585 138.99C276.892 139.213 277.338 139.158 277.589 138.823C277.813 138.487 277.729 138.039 277.422 137.813Z",
    fill: "#2EC5CE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M269.529 156.165C264.37 156.165 260.159 151.936 260.159 146.753C260.159 141.57 264.37 137.341 269.529 137.341C274.689 137.341 278.9 141.57 278.9 146.753C278.9 151.962 274.689 156.165 269.529 156.165ZM269.529 138.88C265.207 138.88 261.693 142.411 261.693 146.753C261.693 151.094 265.207 154.623 269.529 154.623C273.852 154.623 277.366 151.094 277.366 146.753C277.366 142.411 273.852 138.88 269.529 138.88Z",
    fill: "#8C30F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M280.054 140.833H259.295C258.658 140.833 258.142 141.351 258.142 141.99V151.719C258.142 152.358 258.658 152.876 259.295 152.876H280.054C280.691 152.876 281.208 152.358 281.208 151.719V141.99C281.208 141.351 280.691 140.833 280.054 140.833Z",
    fill: "#EAD7FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M265.638 146.281C265.621 146.915 265.493 147.444 265.254 147.867C265.015 148.292 264.673 148.595 264.228 148.783L265.501 150.27L264.022 150.23L263.056 148.992H262.97C262.135 148.969 261.501 148.711 261.067 148.219C260.632 147.731 260.427 147.034 260.451 146.137C260.475 145.237 260.718 144.558 261.179 144.098C261.64 143.635 262.289 143.415 263.126 143.438C263.963 143.458 264.597 143.713 265.028 144.205C265.459 144.694 265.662 145.385 265.638 146.281ZM261.662 146.174C261.646 146.779 261.749 147.236 261.972 147.545C262.195 147.858 262.536 148.02 262.996 148.031C263.917 148.055 264.394 147.462 264.427 146.25C264.459 145.032 264.017 144.413 263.101 144.39C262.641 144.378 262.29 144.52 262.049 144.821C261.807 145.122 261.678 145.573 261.662 146.174Z",
    fill: "#8C30F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M271.271 143.739L271.177 147.23C271.167 147.63 271.067 147.977 270.879 148.272C270.691 148.567 270.425 148.789 270.08 148.94C269.735 149.093 269.331 149.16 268.866 149.148C268.166 149.131 267.627 148.94 267.249 148.573C266.871 148.208 266.69 147.716 266.706 147.097L266.799 143.621L267.951 143.652L267.862 146.956C267.851 147.369 267.927 147.679 268.091 147.875C268.255 148.075 268.532 148.179 268.922 148.191C269.299 148.199 269.576 148.11 269.751 147.919C269.927 147.728 270.02 147.421 270.031 147.005L270.119 143.707L271.271 143.739Z",
    fill: "#8C30F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M272.461 149.165L272.606 143.771L273.761 143.803L273.616 149.197L272.461 149.165Z",
    fill: "#8C30F5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M278.538 149.328L274.484 149.221L274.504 148.477L277.216 144.839L274.674 144.772L274.7 143.826L278.612 143.93L278.593 144.668L275.885 148.312L278.564 148.382L278.538 149.328Z",
    fill: "#8C30F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M272.193 97.367C271.488 97.367 269.099 96.8429 269.099 96.8429C268.533 96.7329 267.924 96.2017 267.924 95.5345V92.3923C267.924 91.9269 268.2 91.5104 268.629 91.3316C268.629 91.3316 271.495 89.7903 272.533 89.1546C273.261 88.7317 273.261 88.7367 273.558 89.2866C273.611 89.3786 273.639 89.4824 273.639 89.5879C273.639 89.8031 273.505 89.9661 273.338 90.1113L272.239 91.0627L271.858 91.3503H272.334H278.502C278.823 91.3503 279.104 91.6568 279.104 92.0064C279.104 92.3391 278.834 92.6099 278.498 92.6102L274.243 92.719V92.9848L274.985 93.043C275.317 93.043 275.587 93.3135 275.587 93.6463C275.587 93.9793 275.317 94.2498 274.98 94.2498L274.083 94.3076V94.5755L274.674 94.6278C275.006 94.6278 275.275 94.8983 275.275 95.2313C275.275 95.5643 275.006 95.8349 274.666 95.8351L274.076 95.8874L273.924 95.895V96.1081L274.218 96.1601L274.227 96.161H274.235C274.567 96.161 274.837 96.4314 274.837 96.7644C274.837 97.0971 274.567 97.3677 274.235 97.3677C274.235 97.3672 272.898 97.367 272.193 97.367Z",
    fill: "#D6B1FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M267.108 91.7734H266.297C266.036 91.7734 265.825 91.9852 265.825 92.2464V95.6002C265.825 95.8614 266.036 96.0732 266.297 96.0732H267.108C267.368 96.0732 267.579 95.8614 267.579 95.6002V92.2464C267.579 91.9852 267.368 91.7734 267.108 91.7734Z",
    fill: "#D6B1FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M267.155 107.772C267.859 107.772 270.249 107.248 270.249 107.248C270.814 107.138 271.424 106.606 271.424 105.94V102.797C271.424 102.332 271.148 101.915 270.719 101.736C270.719 101.736 267.853 100.195 266.815 99.5596C266.087 99.1365 266.087 99.1415 265.789 99.6913C265.737 99.7833 265.709 99.8874 265.709 99.9926C265.709 100.208 265.843 100.371 266.01 100.516L267.109 101.467L267.49 101.755H267.014H260.845C260.525 101.755 260.244 102.062 260.244 102.411C260.244 102.744 260.514 103.015 260.849 103.015L265.105 103.124V103.39L264.362 103.448C264.031 103.448 263.761 103.718 263.761 104.051C263.761 104.384 264.031 104.655 264.368 104.655L265.264 104.712V104.98L264.674 105.033C264.342 105.033 264.072 105.303 264.072 105.636C264.072 105.969 264.342 106.24 264.682 106.24L265.272 106.292L265.424 106.3V106.513L265.13 106.565L265.121 106.566H265.112C264.781 106.566 264.511 106.836 264.511 107.169C264.511 107.502 264.781 107.772 265.112 107.772C265.112 107.772 266.45 107.772 267.155 107.772Z",
    fill: "#2EC5CE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M272.24 102.183H273.051C273.312 102.183 273.523 102.394 273.523 102.656V106.009C273.523 106.271 273.312 106.482 273.051 106.482H272.24C271.98 106.482 271.769 106.271 271.769 106.009V102.656C271.769 102.394 271.98 102.183 272.24 102.183Z",
    fill: "#2EC5CE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M180.202 179.304H178.39L180.531 205.015H182.509L180.202 179.304Z",
    fill: "#2EC5CE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M169.491 179.304H171.304L169.162 205.015H167.185L169.491 179.304Z",
    fill: "#2EC5CE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M185.007 198.266H163.863V200.195H185.007V198.266Z",
    fill: "#75E3EA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M185.967 182.271H162.901V195.785H185.967V182.271Z",
    fill: "#C8D6F1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M178.353 189.809C177.643 190.691 176.569 191.377 176.1 192.418C175.891 192.881 176.659 193.222 176.996 193.26C177.689 193.337 178.305 193.118 178.921 192.873C178.978 193.12 179.164 193.34 179.579 193.536C180.49 193.969 181.52 193.614 182.396 193.249C182.883 193.046 181.809 192.188 181.331 192.387C181.063 192.499 180.789 192.582 180.51 192.661C179.959 192.818 180.281 192.729 180.455 192.285C180.646 191.8 179.818 191.369 179.424 191.456C179.001 191.549 178.594 191.728 178.186 191.898C178.995 191.037 179.983 190.309 180.251 189.101C180.351 188.653 179.522 188.309 179.19 188.374C177.123 188.779 175.28 189.984 173.265 190.525C174.166 189.406 175.34 188.514 176.189 187.335C176.501 186.902 175.472 186.431 175.158 186.506C172.98 187.029 170.778 187.951 168.521 188.008C169.775 186.946 171.404 186.393 172.786 185.498C173.272 185.183 172.153 184.356 171.721 184.636C169.976 185.767 167.938 186.374 166.583 188.028C166.309 188.363 167.099 188.814 167.326 188.851C169.533 189.214 171.608 188.672 173.692 188.084C172.816 188.962 171.9 189.798 171.319 190.923C171.1 191.346 171.883 191.78 172.214 191.766C174.43 191.672 176.324 190.545 178.353 189.809Z",
    fill: "#8C30F5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.648,
    cy: 77.0385,
    rx: 2.97627,
    ry: 2.98577,
    fill: "#95F9FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.656,
    cy: 126.564,
    rx: 2.97627,
    ry: 2.98577,
    fill: "#95F9FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.407,
    cy: 171.092,
    rx: 2.97627,
    ry: 2.98577,
    fill: "#95F9FF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.788,
    cy: 124.066,
    rx: 2.97627,
    ry: 2.98577,
    fill: "#95F9FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4362 36.5138C58.3448 39.879 60.9571 47.218 64.138 49.6526C65.4862 50.6844 67.8195 51.8841 70.3763 53.1988C75.3599 55.7613 81.1928 58.7604 82.2358 61.8045L87.4209 76.9376L92.6679 75.1283L87.4827 59.9952C86.4398 56.9512 89.2019 50.9882 91.5619 45.8934C92.7727 43.2796 93.8776 40.8943 94.3085 39.249C95.3252 35.367 92.8877 27.9677 91.5419 24.7533L57.4362 36.5138Z",
    fill: "url(#paint2_linear_625_2649)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 27.7506,
    height: 8.34615,
    rx: 1.79573,
    transform: "matrix(0.945373 -0.32599 0.324135 0.946011 75.4187 76.2012)",
    fill: "url(#paint3_linear_625_2649)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 0.840636,
    y: 0.410562,
    width: 12.551,
    height: 11.1949,
    transform: "matrix(0.945373 -0.32599 0.324135 0.946011 69.7742 38.5086)",
    stroke: "#EFF5FF",
    strokeWidth: 1.32435,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1456 42.4081L49.6184 45.6934C51.7243 53.9123 62.806 72.0703 83.9417 66.2785",
    stroke: "#FFDF8E",
    strokeWidth: 1.34201,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0694 29.2144L102.823 25.851C106.214 33.6268 112.703 56.86 87.2736 64.3818",
    stroke: "#FFDF8E",
    strokeWidth: 1.34201,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2346 37.1565C47.8799 37.6295 47.2099 37.7243 46.7382 37.3683C46.2666 37.0123 46.1718 36.3402 46.5266 35.8672C46.8813 35.3942 47.5513 35.2994 48.023 35.6554C48.4946 36.0114 48.5894 36.6835 48.2346 37.1565Z",
    fill: "#D9E021"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7358 16.9194L51.769 17.2905L51.3993 18.3266L50.3661 17.9554L50.7358 16.9194Z",
    fill: "#A1C3FC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0568 22.9743L50.8689 23.9844L49.8625 26.8044L47.0503 25.7943L48.0568 22.9743Z",
    fill: "#E94A47"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2626 26.1511L62.0747 27.1611L61.0683 29.9811L58.2561 28.971L59.2626 26.1511Z",
    fill: "#78A9EF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0537 24.3572C54.0806 24.3212 54.086 24.2717 54.0635 24.2291C52.4971 21.2926 48.8763 19.6413 45.6412 20.3886C45.5771 20.4032 45.5376 20.4672 45.5522 20.5313C45.5669 20.5954 45.6308 20.6354 45.6945 20.6206C48.8288 19.8964 52.3367 21.4962 53.8543 24.3415C53.8851 24.3994 53.9572 24.4211 54.0151 24.3904C54.0302 24.3823 54.0436 24.3707 54.0537 24.3572Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3615 34.4358C44.3802 34.4109 44.3892 34.3787 44.3839 34.3453C44.3738 34.2803 44.3126 34.2363 44.248 34.2466C41.8883 34.6246 39.9742 36.9675 40.067 39.3625C40.0695 39.4282 40.1245 39.4793 40.1899 39.4768C40.2556 39.4747 40.3062 39.4192 40.3039 39.3533C40.2155 37.073 42.0388 34.842 44.2853 34.4819C44.3168 34.4768 44.3437 34.4595 44.3615 34.4358Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_625_2649",
    x1: 27.2616,
    y1: 133.867,
    x2: 100.021,
    y2: 252.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A75D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_625_2649",
    x1: 386.292,
    y1: 106.78,
    x2: 251.234,
    y2: 74.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A75D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_625_2649",
    x1: 58.8712,
    y1: 34.5476,
    x2: 90.1713,
    y2: 75.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_625_2649",
    x1: -8.41191,
    y1: 4.17308,
    x2: 6.21229,
    y2: 22.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF8E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.fec07cce638a6884dd902fcbdda02304.svg";
export { ForwardRef as ReactComponent };